import React from "react";
import PitchDeckTableEmptyRow from "../financials-table/financial-table-empty-row";
import PitchDeckTableRow from "./pitch-deck-table-row";
import PitchDeckTableRowHeaderCenter from "./pitch-deck-table-row-center-header";
import PitchDeckWarningRow from "./pitch-deck-warning-row";

// !! rowArray --> an array of objects that can contain the following fields
/* {
  type, --> "rowBreak" or "bodyHeaderCenter" or "warning"
  fieldName,
  displayName,
  className, 
  unitName --> Name for fieldName unit's value if present
} */

const PitchDeckTableRows = ({ props, rowArray }) => {
  return rowArray.map((row, index) =>
    row.type === "rowBreak" ? (
      <PitchDeckTableEmptyRow key={index} />
    ) : row.type === "bodyHeaderCenter" ? (
      <PitchDeckTableRowHeaderCenter
        key={index}
        displayName={row.displayName}
      />
    ) : row.type === "warning" ? (
      <PitchDeckWarningRow key={index} props={props} fieldNames={row.fieldNames} />
    ) : (
      <PitchDeckTableRow
        key={index}
        props={props}
        fieldName={row.fieldName}
        unitName={row.unitName}
        displayName={row.displayName}
        bottomText={row.bottomText}
        className={row.className}
      />
    )
  );
};

export default PitchDeckTableRows;
